import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import CHGReview from './components/CHGReview';
import Software from './components/Software';
import Infrastructure from './components/Infrastructure';
import ITOpsAdvisor from './components/IncidentAdvisor';
import Information from './components/Information';
import Prompts from './components/Prompts';
import Financials from './components/Financials';
import KBUpload from './components/KBUpload';
import KnowledgeBaseDocs from './components/docs/KnowledgeBaseDocs';
import Footer from './components/Footer';

function App() {
  const [currentPage, setCurrentPage] = useState('dashboard');

  return (
    <div className="flex h-screen bg-dark-bg text-gray-100 relative overflow-hidden">
      {/* Neon 80s background effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Grid lines effect */}
        <div className="absolute inset-0" style={{
          backgroundImage: `
            linear-gradient(rgba(178, 75, 243, 0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(178, 75, 243, 0.03) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }} />
        
        {/* Neon glows */}
        <div className="absolute top-0 left-1/3 w-[600px] h-[600px] bg-purple-accent opacity-[0.08] blur-[180px] rounded-full animate-pulse" 
             style={{ animationDuration: '6s' }} />
        <div className="absolute bottom-0 right-1/3 w-[500px] h-[500px] bg-cyan-accent opacity-[0.06] blur-[170px] rounded-full animate-pulse" 
             style={{ animationDuration: '8s', animationDelay: '1s' }} />
        <div className="absolute top-1/2 left-1/2 w-[400px] h-[400px] bg-orange-accent opacity-[0.05] blur-[160px] rounded-full animate-pulse" 
             style={{ animationDuration: '10s', animationDelay: '2s' }} />
      </div>
      
      <Sidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />
      <div className="flex-1 flex flex-col overflow-hidden relative z-10">
        <main className="flex-1 overflow-y-auto pt-16 lg:pt-0">
          {currentPage === 'dashboard' ? <Dashboard /> : currentPage === 'software' ? <Software /> : currentPage === 'infrastructure' ? <Infrastructure /> : currentPage === 'incidentadvisor' ? <ITOpsAdvisor /> : currentPage === 'information' ? <Information /> : currentPage === 'prompts' ? <Prompts /> : currentPage === 'financials' ? <Financials /> : currentPage === 'kbupload' ? <KBUpload /> : currentPage === 'kbdocs' ? <KnowledgeBaseDocs /> : <CHGReview />}
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;

